import { Link } from "react-router-dom";
import { ArrowLeft, Zap } from "lucide-react";

const ToolPageNavbar = () => {
  return (
    <nav className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[95%] max-w-5xl" data-testid="tool-navbar">
      <div className="glass-strong rounded-2xl px-6 py-2">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="back-to-home">
            <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
              <ArrowLeft className="w-4 h-4 text-white" />
            </div>
            <img 
              src="/Tots360_logo.png" 
              alt="tots360"
              className="h-12 lg:h-14 w-auto object-contain"
              style={{ mixBlendMode: 'screen', filter: 'brightness(1.4)' }}
            />
          </Link>

          <Link
            to="/#contact"
            className="flex items-center gap-2 btn-glass px-5 py-2.5 rounded-xl text-sm font-medium text-primary"
            data-testid="tool-nav-book-button"
          >
            <Zap className="w-4 h-4 text-[#FFE66D]" />
            Book Screening
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default ToolPageNavbar;
